// Build só do casomegavazamento (portal.casomegavazamento.com, conta Mishcon): a configuração do port1-v2, com o
// backend pelo proxy do caso. Importa o environment.v2.prod.port1.ts para acompanhar qualquer mudança nele.
import { environment as port1 } from './environment.v2.prod.port1';

export const environment: any = {
  ...port1,
  supabaseUrl: 'https://backend.casomegavazamento.com/',
  lambdaUrl: 'https://backend.casomegavazamento.com/lambda',
};
